import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/contexts/LanguageContext";

export default function TermsHistory() {
  const { lang } = useI18n();
  const it = lang === "it";
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let live = true;
    let request = 0;
    const refresh = () => {
      const current = ++request;
      api.get("/account/terms/history").then(({ data }) => {
        if (live && current === request) { setData(data.items); setError(false); }
      }).catch(() => { if (live && current === request) setError(true); });
    };
    refresh();
    window.addEventListener("nvl-terms-updated", refresh);
    return () => { live = false; window.removeEventListener("nvl-terms-updated", refresh); };
  }, []);
  return <section className="nvl-card p-5 mb-6" aria-label={it ? "Le tue scelte sui Termini" : "Your Terms choices"}>
    <h2>{it ? "Le tue scelte sui Termini" : "Your Terms choices"}</h2>
    {error ? <p role="alert">{it ? "Cronologia non disponibile. Ricarica la pagina o contatta info@gd8.it." : "History unavailable. Reload or contact info@gd8.it."}</p> : data === null ? <p>{it ? "Caricamento…" : "Loading…"}</p> : <>
      {data.length === 0 && <p>{it ? "Nessuna scelta registrata disponibile." : "No recorded choice available."}</p>}
      <ul>{data.map((item, i) => <li key={i}>
        {item.version} · {item.language} · {item.decision === "accept" ? (it ? "Accettati" : "Accepted") : (it ? "Non accettati" : "Declined")} · {item.decided_at || "—"}
        {item.document_verified && item.document_url ? <> · <Link to={item.document_url}>{it ? "Leggi questo testo" : "Read this text"}</Link></> : <p>{it ? "Il testo corrispondente non è verificabile nell’archivio. Contatta l’assistenza." : "The matching text cannot be verified in the archive. Contact support."}</p>}
      </li>)}</ul>
    </>}
  </section>;
}
